<template>
  <div class="comp_qs">
    <div class="page-heading" style="background-image: url('static/menhu/images/pp4.jpg')">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1>品牌诠释</h1>
            <span>走进品牌的故事,体会梵蒂斯妙曼美丽的文化~</span>
          </div>
        </div>
      </div>
    </div>

    <p v-html="qs"></p>

  </div>
</template>

<script>
export default {
  name: 'comp_qs',
  data() {
    return {
        qs:null
    }
  },
  created() {
    this.getData();
  },
  methods:{
    getData(){
      let _this = this;
      this.$axios.get('fantis/compjj/ftCmsCompJj/queryById?id=101')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            _this.qs = tempData.compJjQs;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
p{
  font-size: 15px;
  color: #333;
  line-height: 30px;
  overflow: hidden;
  box-sizing: border-box;
  padding:0 20% 0 20%;
}
</style>



// WEBPACK FOOTER //
// src/components/views/comp/comp_qs.vue